export default __webpack_public_path__ + "static/media/project_support.8df4b6cf.png";